export const OffersPermissions = {
  ViewOffers: {
    permissionsId: "b8d49c29-84e5-44af-b6e7-08dd8b9e8c29",
    permissionsName: "View Offers",
    description: null,
    componentsId: null,
    components: null,
  },
};
